<section class="py-4">
    <div class="flex flex-col gap-2">
        <ng-container *ngFor="let item of categories$ | async">
            <button
                tuiButton
                [appearance]="item.id === selectedCategory?.id ? 'secondary' : 'outline'"
                (click)="handleSelect(item)"
                size="m"
                class="h-max text-left"
            >
                {{ item.name }}
            </button>
        </ng-container>
    </div>
</section>
